// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    rootGet (params?: {}): Promise<Dict>;
    rootGetInfo (params?: {}): Promise<Dict>;
    publicGetAccount (params?: {}): Promise<Dict>;
    publicGetAccountsByL1Address (params?: {}): Promise<Dict>;
    publicGetApikeys (params?: {}): Promise<Dict>;
    publicGetExchangeStats (params?: {}): Promise<Dict>;
    publicGetAssetDetails (params?: {}): Promise<Dict>;
    publicGetOrderBookDetails (params?: {}): Promise<Dict>;
    publicGetOrderBookOrders (params?: {}): Promise<Dict>;
    publicGetOrderBooks (params?: {}): Promise<Dict>;
    publicGetRecentTrades (params?: {}): Promise<Dict>;
    publicGetBlockTxs (params?: {}): Promise<Dict>;
    publicGetNextNonce (params?: {}): Promise<Dict>;
    publicGetTx (params?: {}): Promise<Dict>;
    publicGetTxFromL1TxHash (params?: {}): Promise<Dict>;
    publicGetTxs (params?: {}): Promise<Dict>;
    publicGetAnnouncement (params?: {}): Promise<Dict>;
    publicGetBlock (params?: {}): Promise<Dict>;
    publicGetBlocks (params?: {}): Promise<List>;
    publicGetCurrentHeight (params?: {}): Promise<Dict>;
    publicGetCandles (params?: {}): Promise<Dict>;
    publicGetMarkPriceCandles (params?: {}): Promise<Dict>;
    publicGetFundings (params?: {}): Promise<Dict>;
    publicGetFastbridgeInfo (params?: {}): Promise<Dict>;
    publicGetFundingRates (params?: {}): Promise<Dict>;
    publicGetWithdrawalDelay (params?: {}): Promise<Dict>;
    publicGetPartnerStats (params?: {}): Promise<Dict>;
    publicGetSyntheticSpotInfo (params?: {}): Promise<Dict>;
    publicGetTokenlist (params?: {}): Promise<Dict>;
    publicPostSendTx (params?: {}): Promise<Dict>;
    publicPostSendTxBatch (params?: {}): Promise<Dict>;
    privateGetAccountLimits (params?: {}): Promise<Dict>;
    privateGetAccountMetadata (params?: {}): Promise<Dict>;
    privateGetPnl (params?: {}): Promise<Dict>;
    privateGetL1Metadata (params?: {}): Promise<Dict>;
    privateGetLiquidations (params?: {}): Promise<Dict>;
    privateGetPositionFunding (params?: {}): Promise<Dict>;
    privateGetPublicPoolsMetadata (params?: {}): Promise<Dict>;
    privateGetGetMakerOnlyApiKeys (params?: {}): Promise<Dict>;
    privateGetAccountActiveOrders (params?: {}): Promise<Dict>;
    privateGetAccountInactiveOrders (params?: {}): Promise<Dict>;
    privateGetAccountOrders (params?: {}): Promise<Dict>;
    privateGetExport (params?: {}): Promise<Dict>;
    privateGetExportHistoricalTrades (params?: {}): Promise<Dict>;
    privateGetTrades (params?: {}): Promise<Dict>;
    privateGetAccountTxs (params?: {}): Promise<Dict>;
    privateGetDepositHistory (params?: {}): Promise<Dict>;
    privateGetTransferHistory (params?: {}): Promise<Dict>;
    privateGetWithdrawHistory (params?: {}): Promise<Dict>;
    privateGetReferralPoints (params?: {}): Promise<Dict>;
    privateGetTransferFeeInfo (params?: {}): Promise<Dict>;
    privateGetRfqGet (params?: {}): Promise<Dict>;
    privateGetRfqList (params?: {}): Promise<Dict>;
    privatePostChangeAccountTier (params?: {}): Promise<Dict>;
    privatePostSetMakerOnlyApiKeys (params?: {}): Promise<Dict>;
    privatePostNotificationAck (params?: {}): Promise<Dict>;
    privatePostRfqCreate (params?: {}): Promise<Dict>;
    privatePostRfqRespond (params?: {}): Promise<Dict>;
    privatePostRfqUpdate (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
